export default "__VITE_ASSET__871173cf__"